import React from 'react';
import RoundsSelector from '../Selector/RoundsSelector';
import TimerDurationSelector from '../Selector/TimerDurationSelector';
import TimerSelector from '../Selector/TimerSelector';

interface RoundConfigProps {
    showRounds?: boolean;
    forceTimer?: boolean;
    showTimer?: boolean;
}

const RoundConfig: React.FC<RoundConfigProps> = ({
    showRounds = true,
    forceTimer = true,
    showTimer = true
}) => {
    return (
        <div className="flex flex-col">
            <div className="text-shadow-border shadow-black text-xl">Rounds</div>
            <div className="flex flex-col gap-1 ml-3">
                {showRounds && <RoundsSelector />}
                {showTimer && (
                    <>
                        {!forceTimer && <TimerSelector />}
                        {<TimerDurationSelector />}
                    </>
                )}
            </div>
        </div>
    );
};

export default RoundConfig;